class TabYears {

  constructor(el) {
    this.el = el;
    this.items = el.querySelectorAll('.tabyears__item');
    this.parts = el.querySelectorAll('.tabyears__part');

    if (!this.items.length || !this.parts.length) return;

    this.init();
  }

  init() {

    this.items.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.activate(index);
      });
    });

    this.activate(0);
  }

  activate(index) {

    this.items.forEach(i => i.classList.remove('_active'));
    this.parts.forEach(p => p.classList.remove('_active'));

    if (this.items[index]) this.items[index].classList.add('_active');
    if (this.parts[index]) this.parts[index].classList.add('_active');

  }

}

export function initTabYears() {
  document.querySelectorAll('.tabyears').forEach(el => new TabYears(el));
}
